import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-result',
  templateUrl: './empty-result.component.html',
  styleUrls: ['./empty-result.component.scss']
})
export class EmptyResultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
